import React, {useEffect, useRef, useState} from 'react';
import {FieldProps, WdiModalAppProps} from '@/components/WdiControls';
import {ProFormInstance} from '@ant-design/pro-form';
import {EC} from '@/services/mdm/ec';
import {WdiSelect, WdiSelectFormat, WdiTreeSelect} from '@/components/WdiControls/WdiSelect';
import {Form, message, Tooltip} from 'antd';
import {HorzLayoutOpts, WdiModalForm} from '@/components/WdiControls/WdiModalForm';
import {responseIsSuccess, ResponseStatus} from '@/utils/request';
import {Enum} from '@/enums/system';
import {FormSa} from '@/services/sales/sa';
import {RevenueType} from '@/services/mdm/revenuetype';

const FormSaDetailPrevApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [revTypeOpts, setRevTypeOpts] = useState<any[]>();

  const {row, rowIndex, formSa} = props.data;

  console.log(props.data);

  useEffect(() => {
    if (row) {
      formRef.current?.setFieldsValue({ecId: row.ecId,});
    }
  }, [row]);

  useEffect(() => {
    if (formSa.revenueType) {
      RevenueType.get(formSa.revenueType).then((response) => {
        if (responseIsSuccess(response)) {
          formRef.current?.setFieldsValue({revenueType: response.data.revenueTypeId});
          setRevTypeOpts([{value: response.data.revenueTypeId, label: response.data.revenueTypeName}]);
        }
      });
    }
  }, [formSa.revenueType]);

  return (
    <WdiModalForm
      {...HorzLayoutOpts}
      formRef={formRef}
      title={props.title}
      visible={props.visible}
      modalProps={{
        onCancel: () => {
          props.onClose?.()
        },
      }}
      submitter={{searchConfig: {submitText: '下一步',},}}
      onFinish={async (values) => {
        const entity: any = {};
        entity.ecId = WdiSelectFormat.getvalue(values.ecId);
        entity.revenueType = WdiSelectFormat.getvalue(values.revenueType);
        const response = await FormSa.Buttons.validatePicker({
          rowIndex: rowIndex,
          formSaDetail: entity,
          formSa: {...formSa},
        });

        if (!responseIsSuccess(response)) {
          message.error(response.message);
        } else if (props.onSave) {
          const formSaDetail = Object.assign({}, row, {
            ecId: response.data.ecId,
            ecName: response.data.ecName,
            revenueType: response.data.revenueType,
            revenueTypeName: response.data.revenueTypeName,
            accrualMethodId: response.data.accrualMethodId,
            accrualMethodName: response.data.accrualMethodName,
          });
          props.onSave({
            code: ResponseStatus.SUCCESS,
            data: Object.assign({}, {formSaDetail: formSaDetail}, props.data),
          });
        }
      }}
    >
      <Form.Item name="ecId" label="费用项" rules={[{required: true, message: '费用项不能为空!'}]}>
        <WdiTreeSelect {...{
          placeholder: "请选择费用项",
          dataLoading: async (params) => {
            const response = await EC.searchEc3(Object.assign({
              toParentLevel: Enum.ECLevel.EC2,
              pageTypeIds: String(formSa.pageTypeId),
              isActive: true,
              revenueTypeIds: String(formSa.revenueType),
            }, params));
            const {treeData, dict} = FieldProps.TreeSelect.formatTreeData({
              textField: "ecName",
              valueField: "ecId",
              id: "ecId",
              pId: "parentId",
              level: "ecLevel",
              disabledLevel: [Enum.ECLevel.EC2],
            }, response.data, (node: any, item: any) => {
              node.title = (
                <Tooltip placement="topLeft" title={item.remark}><span>{node.title}</span></Tooltip>
              );
              return node;
            });
            return {treeData, dict};
          },
        }} />
      </Form.Item>
      <Form.Item name="revenueType" label="核算类型" rules={[{required: true, message: '核算类型不能为空!'}]}>
        <WdiSelect {...{
          disabled: true,
          placeholder: "请选择核算类型",
          showSearch: true,
          options: revTypeOpts,
        }} />
      </Form.Item>
    </WdiModalForm>
  );
};
export default FormSaDetailPrevApp;
